import {useDragLayer} from "react-dnd";
import {Chip, Stack} from "@mui/material";
import {chipSx} from ".";

const DragPreview = ({type}: {type: string}) => {
  const {isDragging, item, itemType, currentOffset, initialOffset} =
    useDragLayer(monitor => ({
      itemType: monitor.getItemType(),
      item: monitor.getItem<{label: string}>(),
      isDragging: monitor.isDragging(),
      currentOffset: monitor.getClientOffset(),
      initialOffset: monitor.getInitialClientOffset(),
    }));

  // mostra solo i drag della propria lista
  if (!isDragging || !item || itemType !== type) {
    return null;
  }

  // Calcola la posizione della preview (centrata sul cursore, seguendo il mouse)
  const transform =
    currentOffset && initialOffset
      ? `translate(${currentOffset.x - initialOffset.x}px, ${currentOffset.y - initialOffset.y}px)`
      : "translate(0, 0)";

  return (
    <Stack
      position="fixed"
      top={initialOffset?.y}
      left={initialOffset?.x}
      sx={{
        pointerEvents: "none", // Non interferisce con interazioni
        zIndex: 1000,
        transform,
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      }}>
      <Chip size="small" label={item.label} sx={{...chipSx}} />
    </Stack>
  );
};

export {DragPreview};
